import { render, staticRenderFns } from "./Versions.Vue?vue&type=template&id=091b4e68"
import script from "./Versions.Vue?vue&type=script&lang=js"
export * from "./Versions.Vue?vue&type=script&lang=js"
import style0 from "./Versions.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Versions.Vue
// module id = 211
// module chunks = 0